"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CurrentAddendums = exports.CurrentBid = exports.FolderTreeActions = void 0;
const _CurrentActions = require("../../modules/bid/current/actions");
const _FolderTreeActions = require("../../modules/files/tree/actions");
require("./basicInformation");
require("./billingInformations");
require("./finishings");
require("./list");
require("./participants");
require("./tender");
require("./reliablePartnerSettings");
require("./userGroups");
require("./messages");
require("./message");
require("./questions");
exports.FolderTreeActions = _FolderTreeActions.default('bid');
exports.CurrentBid = _CurrentActions.default('current-bid');
exports.CurrentAddendums = _CurrentActions.default('current-addendum');
//# sourceMappingURL=index.js.map